<div *ngIf="loading; else elseBlock" class="spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>

  <ng-template #elseBlock >

    <div style="display: flex;justify-content: space-between;flex-direction: column;height: 100%;">
      <h2>Asignar Equipos a File {{file.fileNumber}}</h2>

      <mat-form-field appearance="outline" style="width: 100%;font-size: 14px">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
      </mat-form-field>

    <div class="mat-elevation-z8">
      <mat-table [dataSource]="dataSource" matSort >

        <ng-container matColumnDef="Check">
<!--           <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="isAllSelected()">
            </mat-checkbox>
            Seleccionar
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox [checked]="row.checked" (change)="updateCheck(row)">
            </mat-checkbox>
          </td> -->

          <mat-header-cell  *matHeaderCellDef></mat-header-cell>
          <mat-cell  *matCellDef="let element"><mat-checkbox [checked]="element.checked" (change)="updateCheck(element)">
          </mat-checkbox></mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombre">
          <mat-header-cell  *matHeaderCellDef>Nombre</mat-header-cell>
          <mat-cell  *matCellDef="let element">{{ element?.nombreEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="categoria">
          <mat-header-cell  *matHeaderCellDef>Categoría</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.categoria }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="marca">
          <mat-header-cell  *matHeaderCellDef>Marca</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.marcaEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="modelo">
          <mat-header-cell  *matHeaderCellDef>Modelo</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.modeloEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="talla">
          <mat-header-cell  *matHeaderCellDef>Talla</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.tallaEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="observacion">
          <mat-header-cell  *matHeaderCellDef>Observaciones</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.observacionEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="valoracion">
          <mat-header-cell  *matHeaderCellDef>Valoración</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.valoracionEquipo }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="estado">
          <mat-header-cell  *matHeaderCellDef>Estado</mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element?.estado }}</mat-cell>
        </ng-container>

        <mat-header-row  *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row  *matRowDef="let row; columns: displayedColumns"></mat-row>

      </mat-table>
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

    <div style="display: flex;justify-content: center">
      <button mat-raised-button class="buttonPrimary" (click)="closeDialog()">Confirmar</button>
    </div>
    </div>
    
  </ng-template>
